/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext } from 'react';

import { ConfigContext } from '../../../contexts/ConfigContext';
import useWindowSize from '../../../hooks/useWindowSize';

import NavContent from './NavContent';
import useAuth from '../../../hooks/useAuth';
import userService from '../../../services/user-service';

const Navigation = () => {
  const { user } = useAuth();
  const cmpId = JSON.parse(localStorage.getItem('cmpId'));
  const sst_Id = JSON.parse(localStorage.getItem('sstId'));
  const accessId = JSON.parse(localStorage.getItem('accessId'));
  const configContext = useContext(ConfigContext);
  const { layout, layoutType, navFixedLayout, collapseMenu, rtlLayout, boxLayout, subLayout, headerFixedLayout } = configContext.state;
  const windowSize = useWindowSize();

  const scroll = () => {
    if (navFixedLayout && headerFixedLayout === false) {
      const main = document.querySelector('.pcoded-navbar');
      const el = document.querySelector('.pcoded-navbar.menupos-fixed');
      const scrollPosition = window.pageYOffset;
      if (scrollPosition > 60) {
        el.style.position = 'fixed';
        el.style.transition = 'none';
        el.style.marginTop = '0';
      } else {
        main.style.position = 'absolute';
        main.style.marginTop = '56px';
      }
    } else {
      document.querySelector('.pcoded-navbar').removeAttribute('style');
    }
  };
  const [items, setItems] = useState([]);
  
  const fetchMenuLevels = () => {
    var data = {sstId: sst_Id, accessId: accessId, cmpId: cmpId}
    console.log('DARA', data)
    userService
      .getMenuLevels(data)
      .then((response) => {
        setItems(response.data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  useEffect(() => {
    if(user){fetchMenuLevels(user?.id)} else return;
  }, [])

  let navClass = ['pcoded-navbar', layoutType];

  if (layout === 'horizontal') {
    navClass = [...navClass, 'theme-horizontal'];
  } else {
    if (navFixedLayout) {
      navClass = [...navClass, 'menupos-fixed'];
    }

    if (navFixedLayout && !headerFixedLayout) {
      window.addEventListener('scroll', scroll, true);
      window.scrollTo(0, 0);
    } else {
      window.removeEventListener('scroll', scroll, false);
    }
  }

  if (windowSize.width < 992 && collapseMenu) {
    navClass = [...navClass, 'mob-open'];
  } else if (collapseMenu) {
    navClass = [...navClass, 'navbar-collapsed'];
  }

  if (layoutType === 'dark') {
    document.body.classList.add('gradient-able-dark');
  } else {
    document.body.classList.remove('gradient-able-dark');
  }

  if (rtlLayout) {
    document.body.classList.add('gradient-able-rtl');
  } else {
    document.body.classList.remove('gradient-able-rtl');
  }

  if (boxLayout) {
    document.body.classList.add('container');
    document.body.classList.add('box-layout');
  } else {
    document.body.classList.remove('container');
    document.body.classList.remove('box-layout');
  }

  let navBarClass = ['navbar-wrapper'];
  if (layout === 'horizontal' && subLayout === 'horizontal-2') {
    navBarClass = [...navBarClass, 'container'];
  }
  let navContent = (
    <div className={navBarClass.join(' ')}>
      <NavContent navigation={items} />
    </div>
  );
  if (windowSize.width < 992) {
    navContent = (
      <div className="navbar-wrapper">
        <NavContent navigation={items} />
      </div>
    );
  }
  return (
    <React.Fragment>
      <nav className={navClass.join(' ')}>{navContent}</nav>
    </React.Fragment>
  );
};

export default Navigation;
